const sampleEN = {
    table: {
        frozenYoghurt: "Frozen yoghurt",
        iceCreamSandwich: "Ice cream sandwich",
        eclair: "Eclair",
        cupcake: "Cupcake",
        gingerbread: "Gingerbread",
        calories: "Calories",
        fat: "Fat (g)",
        carbs: "Carbs (g)",
        protein: "Protein (g)",
        price: "Price",
    },
};
export default sampleEN;
